import { getNotificaciones, marcarComoLeida } from "@/services/notifications/notificacionService";

export default {
  namespaced: true,

  state: () => ({
    all: [],
    visibles: [],
    notRead: 0,
  }),

  mutations: {
    SET_NOTIFICATIONS(state, payload) {
      state.all = payload.notificaciones;
      state.notRead = payload.notRead;
    },

    PUSH_VISIBLE(state, noti) {
      state.visibles.push(noti);
    },

    REMOVE_VISIBLE(state, id) {
      state.visibles = state.visibles.filter((n) => n.id !== id);
    },

    DECREMENT_NOT_READ(state) {
      if (state.notRead > 0) state.notRead--;
    },
  },

  actions: {
    async fetch({ state, commit }) {
      const result = await getNotificaciones();

      const notificaciones = Array.isArray(result?.notificaciones)
        ? result.notificaciones
        : [];

      const notRead = Number.isInteger(result?.notRead) ? result.notRead : 0;

      commit("SET_NOTIFICATIONS", { notificaciones, notRead });

      const nuevas = notificaciones.filter(
        (n) => !n.read && !state.visibles.find((v) => v.id === n.id),
      );

      nuevas.forEach((n) => {
        if (state.visibles.length < 4) {
          commit("PUSH_VISIBLE", n);
        }
      });
    },
    async remove({ commit }, id) {
      commit("REMOVE_VISIBLE", id);
      await marcarComoLeida(id);
      commit("DECREMENT_NOT_READ");
    },
  },
};
